import React, {useEffect, useRef} from "react";
import {Helmet} from "react-helmet-async";
import {Link, useSearchParams} from "react-router-dom";
import {trackPurchase} from "../util/FacebookPixelUtil";

export default function SystemThankYouPage(): JSX.Element {
    const [searchParams] = useSearchParams();
    const hasFiredPixelRef = useRef(false);

    useEffect(() => {
        if (hasFiredPixelRef.current) return;
        const transactionId = searchParams.get("transactionId");
        const priceStr = searchParams.get("price");
        const purchaseOptionName = searchParams.get("purchaseOptionName") ?? undefined;
        const email = searchParams.get("em") ?? undefined;

        if (!transactionId || !priceStr) return;
        const price = parseFloat(priceStr);
        if (Number.isNaN(price)) return;

        hasFiredPixelRef.current = true;
        trackPurchase(
            email,
            undefined,
            price,
            "USD",
            transactionId,
            purchaseOptionName ? [purchaseOptionName] : undefined,
            "Effective Action System"
        ).catch(err => console.error("Failed to track Purchase event:", err));
    }, [searchParams]);

    return (
        <>
            <Helmet>
                <title>Welcome to Effective Action System</title>
                <meta name="robots" content="noindex"/>
            </Helmet>
            <main style={{
                minHeight: "100vh", background: "#0b1410", color: "#fff",
                display: "flex", alignItems: "center", justifyContent: "center",
                padding: "2rem", textAlign: "center",
            }}>
                <div style={{maxWidth: 560}}>
                    <div style={{
                        width: 72, height: 72, margin: "0 auto 1.5rem",
                        borderRadius: "50%", background: "rgba(42,209,103,0.15)",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        border: "2px solid #2ad167", fontSize: "2rem", color: "#2ad167",
                    }}>✓</div>
                    <h1 style={{fontSize: "2rem", margin: "0 0 1rem", fontWeight: 700}}>
                        You're in.
                    </h1>
                    <p style={{fontSize: "1.1rem", color: "rgba(255,255,255,0.78)", lineHeight: 1.55, marginBottom: "2rem"}}>
                        Stripe is processing your payment. We've sent onboarding instructions to the email you used at checkout — check your inbox in the next few minutes.
                    </p>
                    <p style={{fontSize: "0.95rem", color: "rgba(255,255,255,0.55)", marginBottom: "2rem"}}>
                        Don't see it? Check spam, or write us at <a href="mailto:support@effectiveactionsystem.com" style={{color: "#2ad167"}}>support@effectiveactionsystem.com</a>.
                    </p>
                    <Link to="/" style={{
                        display: "inline-block", padding: "0.75rem 1.5rem",
                        background: "#2ad167", color: "#0b1410", textDecoration: "none",
                        borderRadius: 10, fontWeight: 700,
                    }}>Back to home</Link>
                </div>
            </main>
        </>
    );
}
